module.exports = __webpack_public_path__ + "media/videos/showreel-60.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/media/videos/showreel-60.mp4
// module id = 153
// module chunks = 0